var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragGw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5AAD26;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st0",
    width: 64,
    height: 64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,57L21.81,46.81l2.75-2.75l5.56,5.56V33.88H14.38l5.25,5.25l-2.75,2.75L7,32l9.94-9.94l2.75,2.75l-5.31,5.31 h15.75V14.38l-5.25,5.25l-2.75-2.75L32,7l9.88,9.88l-2.75,2.75l-5.25-5.25v15.75h15.75l-5.25-5.25l2.75-2.75L57,32l-9.88,9.88 l-2.75-2.75l5.25-5.25H33.88v15.75l5.56-5.56l2.75,2.75L32,57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragGw);
export default __webpack_public_path__ + "static/media/drag_gw.a78d8d1246eaacee85f4c37db75d952d.svg";
export { ForwardRef as ReactComponent };